import Nav from "@/components/Nav";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Portfolio from "@/components/sections/Portfolio";
import MusicSection from "@/components/sections/MusicSection";
import Credits from "@/components/sections/Credits";
import Booking from "@/components/sections/Booking";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-warmwhite text-charcoal min-h-screen overflow-x-hidden">
      <Nav />
      <main>
        <Hero />
        <About />
        <Services />
        <Portfolio />
        <MusicSection />
        <Credits />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
